import { defineMessages, type IntlShape } from 'react-intl';
import type { JSONSchema } from '@plone/types';
import { addStyling } from '@plone/volto/helpers/Extensions/withBlockSchemaEnhancer';

const addCardStyles = ({
  schema,
  intl,
  formData,
}: {
  schema: JSONSchema;
  intl: IntlShape;
  formData: JSONSchema;
}): JSONSchema => {
  addStyling({ schema, intl, formData });

  // @ts-expect-error
  schema.properties.styles.schema.fieldsets[0].fields = [
    // @ts-expect-error
    ...schema.properties.styles.schema.fieldsets[0].fields,
    'cardBg',
  ];
  // @ts-expect-error
  schema.properties.styles.schema.properties['cardBg'] = {
    widget: 'color_picker',
    title: intl.formatMessage(messages.card_color_title),
    colors: [
      {
        name: 'white',
        label: 'white',
      },
      { name: 'gray', label: 'Gray' },
      {
        name: 'black',
        label: 'Black',
      },
    ],
    default: 'white',
  };

  return schema;
};

export default addCardStyles;
const messages = defineMessages({
  card_color_title: {
    id: 'card_color_title',
    defaultMessage: 'Card color',
  },
});
